/* Wishlist page: draws the saved books, lets people add them all to the cart, share the list,
   and open a list someone shared with them (?l=handle,handle). */
(function(){
  var root=document.querySelector('[data-wl]');if(!root)return;
  var KEY='mb_wishlist';
  function q(s){return root.querySelector(s)}
  function saved(){try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return []}}
  function store(l){try{localStorage.setItem(KEY,JSON.stringify(l))}catch(e){}}
  function toast(t){var el=document.querySelector('.mb-toast');if(!el)return;el.textContent=t;el.classList.add('is-on');setTimeout(function(){el.classList.remove('is-on')},2500)}

  var shared=(new URLSearchParams(location.search).get('l')||'').split(',').map(function(s){return s.trim()}).filter(Boolean);
  var SHARED=shared.length>0,books=[],byH={};

  function money(p){return window.mbMoney?window.mbMoney(p):'₹'+(p/100).toFixed(2)}
  function live(){return books.filter(function(b){return !b._gone})}

  function sum(){
    var l=live(),inStock=l.filter(function(b){return b.av}),tot=inStock.reduce(function(s,b){return s+b.p},0),out=l.length-inStock.length;
    q('[data-wl-sum]').innerHTML=l.length?('<b>'+l.length+(l.length===1?' book':' books')+'</b>'+(inStock.length?' · '+money(tot)+' for the ones in stock':'')+(out?' · '+out+' sold out':'')):'';
    var btn=q('[data-wl-all]');btn.disabled=!inStock.length;
    btn.textContent=inStock.length?'Add '+(inStock.length===l.length?'all ':'')+inStock.length+' to cart':'Nothing in stock';
    q('[data-wl-acts]').hidden=SHARED||!l.length;
    q('[data-wl-shared]').hidden=!SHARED||!l.length;
    q('[data-wl-quote]').hidden=l.length<10;
    q('[data-wl-empty]').hidden=!!l.length||SHARED&&books.length>0;
    if(!l.length)q('[data-wl-sharebox]').hidden=true;
  }

  function draw(){
    var grid=q('[data-wl-grid]');
    if(!books.length){grid.innerHTML='';grid.hidden=true;sum();
      if(SHARED){q('[data-wl-empty]').hidden=false;q('[data-wl-empty] h2').textContent='These books are no longer on the site'}
      return}
    grid.hidden=false;
    grid.innerHTML=books.map(function(b){return window.mbCard(b)}).join('');
    // the cards keep their order; mark each with its handle for undo
    [].forEach.call(grid.querySelectorAll('.mb-card'),function(c,i){c.setAttribute('data-h',books[i].h)});
    if(window.mbPaintWish)window.mbPaintWish(grid);
    sum();
  }

  function start(){
    if(SHARED){
      q('[data-wl-title]').textContent='A shared list';
      document.title='A shared list · '+document.title.split(' · ').pop();
    }
    var want=SHARED?shared:saved();
    if(!want.length){books=[];draw();return}
    if(!window.mbLoad){q('[data-wl-grid]').innerHTML='<p class="mb-wl__load">Couldn’t load your books. Please refresh.</p>';return}
    window.mbLoad('/collections/all','local').then(function(items){
      items.forEach(function(it){byH[it.h]=it});
      // newest saves first
      books=want.slice().reverse().map(function(h){return byH[h]}).filter(Boolean);
      draw();
    }).catch(function(){q('[data-wl-grid]').innerHTML='<p class="mb-wl__load">Couldn’t load your books. Please refresh.</p>'});
  }

  // a heart tapped on this page: mb.js updates the saved list, then we show Undo on that card
  root.addEventListener('click',function(e){
    var heart=e.target.closest('[data-wish]');
    if(heart&&!SHARED){
      var card=heart.closest('.mb-card'),h=heart.getAttribute('data-wish'),b=byH[h];
      setTimeout(function(){
        var on=saved().indexOf(h)>-1;
        if(b)b._gone=!on;
        card.classList.toggle('is-gone',!on);
        var u=card.querySelector('.mb-wl__undo');
        if(!on&&!u){u=document.createElement('div');u.className='mb-wl__undo';u.innerHTML='Removed<button type="button" data-wl-undo>Undo</button>';card.appendChild(u)}
        if(on&&u)u.remove();
        sum();
      },0);
      return;
    }
    var undo=e.target.closest('[data-wl-undo]');
    if(undo){var c=undo.closest('.mb-card'),hh=c.getAttribute('data-h');var l=saved();if(l.indexOf(hh)<0){l.push(hh);store(l)}
      if(byH[hh])byH[hh]._gone=false;c.classList.remove('is-gone');undo.parentNode.remove();if(window.mbPaintWish)window.mbPaintWish(c);sum();return}
  });

  // add every in-stock book to the cart
  q('[data-wl-all]').addEventListener('click',function(){
    var btn=this,list=live().filter(function(b){return b.av});if(!list.length)return;
    btn.disabled=true;var label=btn.textContent;btn.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:list.map(function(b){return {id:b.vid,quantity:1}})})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(function(){location.href='/cart'})
      .catch(function(err){btn.disabled=false;btn.textContent=label;toast((err&&err.description)||'Could not add the books. Please try again.')});
  });

  // share: a link that opens this page with the same books
  function link(){return location.origin+'/pages/wishlist?l='+live().map(function(b){return b.h}).join(',')}
  q('[data-wl-share]').addEventListener('click',function(){
    var url=link(),text='My Medallied Books list ('+live().length+' books): '+url;
    if(navigator.share){navigator.share({title:'My book list',text:'My Medallied Books list',url:url}).catch(function(){});return}
    var box=q('[data-wl-sharebox]');box.hidden=!box.hidden;
    q('[data-wl-wa]').href='https://wa.me/?text='+encodeURIComponent(text);
  });
  q('[data-wl-copy]').addEventListener('click',function(){
    var url=link();
    (navigator.clipboard?navigator.clipboard.writeText(url):Promise.reject()).then(function(){toast('Link copied')}).catch(function(){window.prompt('Copy this link',url)});
  });

  // a shared list: save its books into my own wishlist
  q('[data-wl-keep]').addEventListener('click',function(){
    var l=saved(),n=0;books.forEach(function(b){if(l.indexOf(b.h)<0){l.push(b.h);n++}});store(l);
    toast(n?n+(n===1?' book':' books')+' saved to your wishlist':'You already have all of these');
    setTimeout(function(){location.href='/pages/wishlist'},900);
  });

  if(window.mbLoad)start();else document.addEventListener('DOMContentLoaded',start);
})();
